<template>
  <span class="hover-tip" @mouseenter="show" @mouseleave="hide"><slot /></span>
</template>

<script>
import { showHoverTip, hideHoverTip } from "./hoverTipPopup";

/**
 * Gestaltetes Mouseover (Ersatz fuer md-tooltip): Inhalt kommt aus dem Slot "tip".
 * Ohne Slot-Inhalt oder mit disabled erscheint nichts.
 */
export default {
  name: "HoverTip",
  props: {
    direction: { type: String, default: "top" },
    disabled: { type: Boolean, default: false },
    tipClass: { type: String, default: "" },
  },
  methods: {
    show() {
      if (this.disabled || !this.$scopedSlots.tip) return;
      showHoverTip(this.$el, { content: () => this.$scopedSlots.tip(), placement: this.direction, className: this.tipClass });
    },
    hide() {
      hideHoverTip(this.$el);
    },
  },
  beforeDestroy() {
    hideHoverTip(this.$el);
  },
};
</script>

<style>
.hover-tip-popup.md-tooltip {
  z-index: 99999 !important;
  position: fixed;
  pointer-events: none;
  height: auto;
  line-height: 1.4;
  transition: none;
}
.hover-tip-popup--text.md-tooltip {
  white-space: pre-line;
  text-align: left;
  min-width: 0;
  max-width: 420px;
}
</style>
